import React from 'react';
var styles = require('./status.scss');
export var CaseStatus;
(function (CaseStatus) {
    CaseStatus["PENDING"] = "inReview";
    CaseStatus["IN REVIEW"] = "inReview";
    CaseStatus["PROCESSING"] = "paymentProcessing";
    CaseStatus["AWAITING CUSTOMER"] = "awaitingCustomer";
    CaseStatus["RELEASED FOR PAYMENT"] = "releasedForPayment";
    CaseStatus["PAID"] = "paymentProcessing";
    CaseStatus["FINAL PAYMENT"] = "paymentProcessing";
    CaseStatus["DENIED"] = "denied";
    CaseStatus["CLOSED"] = "closed";
})(CaseStatus || (CaseStatus = {}));
var Status = function (props) {
    var displayText = ['FINAL PAYMENT', 'PROCESSING', 'PAID'].includes(props.status)
        ? 'PAYMENT PROCESSING'
        : props.status;
    return React.createElement("div", { className: [styles.status, styles[CaseStatus[props.status] || 'default']].join(' ') }, displayText);
};
export default Status;
